module.exports = __webpack_public_path__ + "img/pinterest.636e0d2.png";